import {
    DOMAIN,
    Header,
    ContentType,
    GetFormData,
    Method,
    http
} from './api-utils';

/**
 * 登录
 * @param {*} param0
 */
export const login = async ({username, password}) => {
    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/login',
        data: {
            username,
            password
        }
    });
};

/**
 * 退出登录
 */
export const logout = async () => {
    await http({
        method: Method.GET,
        url: DOMAIN + '/api/user/logout'
    });
};

/**
 * 注册
 * @param {*} param0
 */
export const register = async ({
                                   username,
                                   password,
                               }) => {
    const formData = GetFormData({
        username,
        password
    });

    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/register',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });
};

/**
 * 修改密码
 * @param {*} param0
 */
export const modifyPassword = async ({verify, password, newPassword}) => {
    await http({
        method: Method.POST,
        url: DOMAIN + '/api/user/modify/password',
        data: {
            code: verify,
            password: password,
            newPassword: newPassword
        }
    });
};

/**
 * 修改用户信息
 * @param {*} param0
 */
export const modifyUserInfo = async ({
                                         avatar,
                                         nickname,
                                         gender,
                                         birthday
                                     }) => {
    const formData = GetFormData({
        avatarFile: avatar,
        nickName: nickname,
        gender,
        birthday
    });

    await http({
        method: Method.PUT,
        url: DOMAIN + '/api/user/update',
        headers: {
            [Header.ContentType]: ContentType.FormData
        },
        data: formData
    });
};

/**
 * 用户信息
 */
export const userInfo = async () => {
    const {data} = await http({
        method: Method.GET,
        url: DOMAIN + '/api/user/info'
    });

    let {
        id,
        name: username,
        avatar,
        nickName: nickname,
        gender,
        birthday
    } = data.msg;

    if (gender === '男') {
        gender = 0;
    } else {
        gender = 1;
    }

    let info = {id, username, avatar, nickname, gender, birthday};

    return {
        info
    };
};

/**
 * 联系人信息
 */
export const contactInfo = () => {
    return http({
        method: Method.GET,
        url: DOMAIN + '/cart/business/contact'
    })
        .then(res => res.data)
        .then(data => {
            const {name, telPhone: phone} = data;

            return {
                name,
                phone
            };
        });
};
